var exports = {
  "n": "xfb577c5e--c40281--link",
};

module.exports = exports;
